// import APIs
import { creditDutyLine } from 'RestAPIs/employees/hours-table';

// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// import external libraries
import { useMutation, useQueryClient } from 'react-query';

// import types
import { CreditDutyLineParams } from './useCreditDutyLine.types';

const useCreditDutyLine = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: CreditDutyLineParams) => creditDutyLine(params),

    {
      onSuccess: (_data, { employeeId }) => {
        queryClient.invalidateQueries(['hoursTable', employeeId]);
        showSuccessSnackbar();
      },
      onError: showErrorSnackbar
    }
  );
};

export default useCreditDutyLine;
